import { useCallback, useContext, useEffect, useState } from 'react';
import { DealRoom } from 'models/DealRoom';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import useShowGetBuyers from 'hooks/useShowGetBuyers';

const useActiveBanner = (deals: DealRoom[]) => {
  const [activeBanner, setActiveBanner] = useState(null);

  const {
    currentUser: { _id: currentUserId },
  } = useContext(CurrentUserContext);

  const getShowGetBuyers = useShowGetBuyers();

  const canManageDeal = useCallback(
    ({ userId, isColleague }: DealRoom) =>
      isColleague || currentUserId === userId,
    [currentUserId],
  );

  const checkIfDealHasBanner = useCallback(
    (deal: DealRoom) => getShowGetBuyers(deal) && canManageDeal(deal),
    [canManageDeal, getShowGetBuyers],
  );

  const displayDealNotification = useCallback(
    (deal) => checkIfDealHasBanner(deal) && activeBanner?._id === deal._id,
    [checkIfDealHasBanner, activeBanner],
  );

  useEffect(() => {
    if (deals.length) {
      const active = deals.find(checkIfDealHasBanner);

      if (active) {
        setActiveBanner(active);
      }
    }
  }, [checkIfDealHasBanner, deals]);

  return displayDealNotification;
};

export default useActiveBanner;
